module.exports = __webpack_public_path__ + "img/WINTER HAT GREEN.0532f3c.svg";